// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.CrossFilteringSlider.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Cross Filtering Slider Component
 */

import React, { PropTypes } from 'react';
import { observer, propTypes as MobxPropTypes } from 'mobx-react';
import connect from 'share/enhancers/Izenda.Connect';
import Slider from 'react-slick';
import CrossFilterItem from './Izenda.CrossFilterItem';
import Dimensions from 'share/components/hoc/Izenda.Dimensions';
import { flatMap, flow, head, get, isEmpty } from 'lodash/fp';

const PrevArrow = observer(({ localization, className, onClick }) => {
  return (
    <button title={localization.getText('CROSSFILTERING_PREVIOUS_TOOLTIP')} className={className} onClick={onClick} />
  );
});

const NextArrow = observer(({ localization, className, onClick }) => {
  return <button title={localization.getText('CROSSFILTERING_NEXT_TOOLTIP')} className={className} onClick={onClick} />;
});

class CrossFilteringSlider extends React.Component {
  static propTypes = {
    crossFilteringDetail: MobxPropTypes.arrayOrObservableArray.isRequired,
    removeCrossFiltering: PropTypes.func.isRequired,
    localization: PropTypes.object.isRequired
  };
  static displayName = 'CrossFilteringSlider';

  constructor(props: Object) {
    super(props);
    this.slider = null;

    this.settings = {
      autoplay: false,
      centerMode: false,
      dots: false,
      draggable: false,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: <PrevArrow localization={props.localization} />,
      nextArrow: <NextArrow localization={props.localization} />
    };
  }

  /**
   * Render cross filtering group
   * @param {Object} localization
   * @param {Array} crossFilteringDetail
   * @param {Object} styles
   * @param {Function} removeCrossFiltering
   */
  renderCrossFilteringGroups = (
    localization: Object,
    crossFilteringDetail: Array,
    styles: Object,
    removeCrossFiltering: Function
  ) => {
    const onRemoveCrossFiltering = (pill: Object) => {
      removeCrossFiltering(pill);
      // recalculate items to show.
      for (let index = 0; index < this.settings.slidesToShow - 1; index++) {
        this.slider.slickPrev();
      }
    };

    const pills = flatMap((group: Object) => {
      return group.pillDefinitions.toJS();
    }, crossFilteringDetail);

    return pills.map((item: Object, index: Number) => (
      <div key={item.id} style={styles}>
        <CrossFilterItem localization={localization} pill={item} removeCrossFiltering={onRemoveCrossFiltering} />
      </div>
    ));
  };

  /**
   * Set ref
   * @param {Object} component
   */
  setRef = (component: Object) => {
    this.slider = component;
  };

  render() {
    let { crossFilteringDetail, localization, removeCrossFiltering, width } = this.props;
    const styles = {
      width: width / this.settings.slidesToShow
    };
    const hasFilter = flow(head, get('pillDefinitions'), isEmpty)(crossFilteringDetail);

    return (
      <div>
        {!hasFilter && (
          <Slider ref={this.setRef} {...this.settings}>
            {this.renderCrossFilteringGroups(localization, crossFilteringDetail, styles, removeCrossFiltering)}
          </Slider>
        )}
      </div>
    );
  }
}

export default connect(Dimensions)(CrossFilteringSlider);



// WEBPACK FOOTER //
// ./ui/modules/CrossFiltering/Izenda.CrossFilteringSlider.js